import React from 'react';
import { useIntl } from 'react-intl';

import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';

interface AnalysisFeedbackLoadingScreenProps {
  isSubmitting: boolean;
}

export const AnalysisFeedbackLoadingScreen = ({ isSubmitting }: AnalysisFeedbackLoadingScreenProps) => {
  const intl = useIntl();

  return (
    <LoadingWizardScreen
      text={
        isSubmitting
          ? intl.formatMessage({ id: 'aiInsights.feedback.sending', defaultMessage: 'Sending…' })
          : intl.formatMessage({ id: 'aiInsights.feedback.loading', defaultMessage: 'Loading feedback…' })
      }
    />
  );
};
